// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ethics_wrapper__3TAyd","borderWrap":"ethics_borderWrap__pFzJs","grid":"ethics_grid__OjFLS","header":"ethics_header__ci275","item":"ethics_item__xWNlN"};